import useBaseShow from "../../base/hooks/useBaseShow";
import { SingleHousekeepingResponseSchema } from "../response/IndexHousekeepingResponse";

const API_VERSION = "v3";

const useShowHousekeeping = (id?: string, include?: string[]) => {
    return useBaseShow({
        id,
        queryKey: "housekeeping",
        endpoint: `${API_VERSION}/housekeeping`,
        schema: SingleHousekeepingResponseSchema,
        include: include, // Bisa dikosongkan jika tidak perlu
    });
};

export default useShowHousekeeping;